<template>
  <div class="page" :class="{ 'page__has-bar': !readonly }">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.si_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="si_vendname">
            <label class="weui-form-preview__label">{{customLabel.si_vendname || "供应商"}}</label>
            <em class="weui-form-preview__value">{{ form.main.si_vendname }}</em>
          </div>
          <div class="weui-form-preview__item" slot="si_contact">
            <label class="weui-form-preview__label">{{customLabel.si_contact || "联系人"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              {{ form.main.si_contact }}
              {{ form.main.si_tel }}
              <call-mobile :mobile="form.main.si_tel"></call-mobile>
            </span>
          </div>
          <div class="weui-form-preview__item" slot="si_startdate">
            <label class="weui-form-preview__label">{{customLabel.si_startdate || "询价日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.si_startdate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="si_enddate">
            <label class="weui-form-preview__label">{{customLabel.si_enddate || "截止日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.si_enddate
            }}</span>
          </div>
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.sid_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="sid_prodname">
            <label class="weui-form-preview__label">{{customLabel.sid_prodname || "物料"}}</label>
            <span class="weui-form-preview__value">
              {{ item.sid_prodname }}
              {{ item.sid_prodcode }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="item.pr_orispeccode" slot="pr_orispeccode">
            <label class="weui-form-preview__label">{{customLabel.pr_orispeccode || "型号"}}</label>
            <span class="weui-form-preview__value">
              {{ item.pr_orispeccode }}
            </span>
          </div>
          <div class="weui-form-preview__item" v-if="item.productDTO.pr_spec" slot="pr_spec">
            <label class="weui-form-preview__label">{{customLabel.pr_spec || "规格"}}</label>
            <span class="weui-form-preview__value">
              {{ item.productDTO.pr_spec }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sid_planqty">
            <label class="weui-form-preview__label">{{customLabel.sid_planqty || "数量"}}</label>
            <span class="weui-form-preview__value">
              {{ item.sid_planqty }}
              {{ item.sid_unit }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sid_sacode">
            <label class="weui-form-preview__label">{{customLabel.sid_sacode || "打样申请单号"}}</label>
            <span class="weui-form-preview__value">
              {{ item.sid_sacode }}
            </span>
          </div>
          </custom-layout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";
import CallMobile from "@/components/button/CallMobile.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    CallMobile,
  },
  data() {
    return {
      baseUrl: "/api/sample/sampleInquiry",
      codeField: "si_code",
      statusField: "si_statuscode",
      caller: "SampleInquiry",
      xtype: "sample-sampleInquiry-formpanel",
    };
  },
}
</script>